import Vue from 'vue'
import Router from 'vue-router'
import App from './App.vue'
import router from './router'
import store from './store'
import api from './http/index'

/* permission control */
import './permission'
import './icons' // icon

/** gtag */
import './gtag'
import gtagMixin from './gtagMixin'

Vue.use(gtagMixin)

/* polyfill */
// import '@babel/polyfill'
import Es6Promise from 'es6-promise'

/* style */
import './style/reset.scss'
// import './style/element-variables.scss'

/* Element UI */
import { Menu, MenuItem, Dropdown, DropdownMenu, DropdownItem, Carousel, CarouselItem, Select, Option, Tabs, TabPane, Loading, Cascader, Collapse, CollapseItem, Radio, RadioGroup, Scrollbar,
  Backtop, Badge, Button, Dialog, drawer, Icon, Image, Step, Steps, Switch, Checkbox, CheckboxGroup, Pagination, InfiniteScroll, MessageBox, Message, Tooltip, Input, Form, FormItem, Notification } from 'element-ui'

/* Element UI */
Vue.use(Loading.directive)
Vue.use(InfiniteScroll)
Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
Vue.prototype.$notify = Notification

Vue.component(Menu.name, Menu)
Vue.component(MenuItem.name, MenuItem)
Vue.component(Dropdown.name, Dropdown)
Vue.component(DropdownMenu.name, DropdownMenu)
Vue.component(DropdownItem.name, DropdownItem)
Vue.component(Carousel.name, Carousel)
Vue.component(CarouselItem.name, CarouselItem)
Vue.component(Select.name, Select)
Vue.component(Option.name, Option)
Vue.component(Tabs.name, Tabs)
Vue.component(TabPane.name, TabPane)
Vue.component(Cascader.name, Cascader)
Vue.component(Collapse.name, Collapse)
Vue.component(CollapseItem.name, CollapseItem)
Vue.component(Scrollbar.name, Scrollbar)

Vue.component(Dialog.name, Dialog)
Vue.component(Button.name, Button)
Vue.component(Badge.name, Badge)
Vue.component(Switch.name, Switch)
Vue.component(Step.name, Step)
Vue.component(Steps.name, Steps)
Vue.component(Image.name, Image)
Vue.component(Backtop.name, Backtop)
Vue.component(drawer.name, drawer)
Vue.component(Icon.name, Icon)
Vue.component(Checkbox.name, Checkbox)
Vue.component(CheckboxGroup.name, CheckboxGroup)
Vue.component(Radio.name, Radio)
Vue.component(RadioGroup.name, RadioGroup)
Vue.component(Pagination.name, Pagination)
Vue.component(Tooltip.name, Tooltip)
Vue.component(Input.name, Input)
Vue.component(Form.name, Form)
Vue.component(FormItem.name, FormItem)

Vue.use(api)
Es6Promise.polyfill()

Vue.config.productionTip = false

/* router 重复点击问题 */
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
